import React, { useRef, useState } from 'react';
import { uploadAnswerBlob } from '../../utils/uploadAnswer';

export default function PhotoAnswer({ attemptId, questionId, onSaved, disabled = false }) {
    const inputRef = useRef(null);
    const [thumb, setThumb] = useState('');
    const [err, setErr] = useState('');

    async function onPick(file) {
        if (!file) return;
        setErr('');
        try {
            // downscale do max 2000px szerokości i PNG
            const img = await readImage(file);
            const { canvas } = scaleToMax(img, 2000);
            const blob = await new Promise(res => canvas.toBlob(res, 'image/png', 0.92));
            setThumb(canvas.toDataURL('image/png', 0.8));

            const filename = `photo-${questionId}-${Date.now()}.png`;
            const { file_key, meta } = await uploadAnswerBlob({
                attemptId, questionId, blob, filename, contentType: 'image/png',
                extraMeta: { kind: 'photo', source: 'rear_or_picker', width: canvas.width, height: canvas.height }
            });
            onSaved?.({ file_key, meta });
        } catch (e) {
            setErr(e.message || 'Błąd przetwarzania zdjęcia');
        }
    }

    return (
        <div style={{ display:'grid', gap:8 }}>
            <div style={{ fontSize:14, opacity:0.8 }}>
                Zrób zdjęcie obliczeń (tylna kamera jeśli dostępna) lub wybierz z galerii.
            </div>
            <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={e=>onPick(e.target.files?.[0] || null)}
                    disabled={disabled}
                />
                {thumb && <img src={thumb} alt="Podgląd" style={{ height:80, border:'1px solid #ddd', borderRadius:6 }} />}
            </div>
            {err && <div style={{ color:'#a00' }}>{err}</div>}
        </div>
    );
}

function readImage(file){
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = ()=>{ URL.revokeObjectURL(url); resolve(img); };
        img.onerror = ()=>{ URL.revokeObjectURL(url); reject(new Error('Nie udało się wczytać obrazu')); };
        img.src = url;
    });
}
function scaleToMax(img, maxW){
    const ratio = img.width > maxW ? maxW / img.width : 1;
    const w = Math.round(img.width * ratio);
    const h = Math.round(img.height * ratio);
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0,0,w,h);
    ctx.drawImage(img, 0, 0, w, h);
    return { canvas: c, width: w, height: h };
}
